import ChangelogsItem from "./changelogItem";

export default class Changelogs {
    id: number;
    version: string;
    date: string;
    changes: ChangelogsItem[];

    constructor(id: number, version: string, date: string, changes: ChangelogsItem[]) {
        this.id = id;
        this.version = version;
        this.date = date;
        this.changes = changes;
    }
}